import React, { RefObject, useRef, useState } from 'react';
import styled from 'styled-components';
import MaterialIcon from '../../../shared/common/MaterialIcon';
import { StockDetails } from '../../../store/api';
import { Trans, useTranslation } from 'react-i18next';
import { LibxStatisticsDropdown } from './LibxStatisticsDropdown';

const StStatLine = styled.li<{ detail?: boolean }>`
    margin: ${props => (!props.detail ? '2px 5px 0px 0px' : '')};
    display: ${props => (!props.detail ? '' : 'block')};
    height: ${props => (!props.detail ? '13px' : '')};
    position: relative;
    cursor: default;
    font-size: 11px;
`;

const StMaterialIcon = styled(MaterialIcon)<{ detail?: boolean }>`
    margin-right: ${props => (!props.detail ? '2px' : '5px')};
    height: inherit;
    vertical-align: middle;
    font-size: 12px;
`;

const StStatisticsLabel = styled.span`
    line-height: 1;
`;

interface LibXStatisticsProps {
    activeLibraries?: number;
    copyAmount?: number;
    stockDetails?: StockDetails;
    detailView?: boolean;
}

export const LibxStatisticsWithStockDetails = (props: LibXStatisticsProps) => {
    const { t } = useTranslation();
    const { activeLibraries = 0, copyAmount = 0, stockDetails, detailView = false } = props;
    const toggleRef = useRef<HTMLElement>(null);
    const [showStockSplit, setShowStockSplit] = useState(false);

    return (
        <div className={detailView ? 'pd-counts' : ''} data-displayname="LibxStatistics">
            <ul className={detailView ? 'prd-dtl' : ''}>
                <StStatLine
                    detail={detailView}
                    className="material-link"
                    title={t('components.productStatistics.copiesInYourLibrary')}
                    ref={toggleRef as RefObject<HTMLLIElement>}
                    onMouseEnter={() => setShowStockSplit(true)}
                    onMouseLeave={() => setShowStockSplit(false)}
                >
                    <StMaterialIcon icon="content_copy" detail={detailView} />
                    {detailView ? (
                        <Trans
                            i18nKey="components.productStatistics.inYourLibraryWithLabels"
                            components={{ span: <span /> }}
                            values={{ copyStockAmount: copyAmount }}
                        />
                    ) : (
                        <StStatisticsLabel>{copyAmount}</StStatisticsLabel>
                    )}
                </StStatLine>
                <LibxStatisticsDropdown visible={showStockSplit} popoverRef={toggleRef} stockDetails={stockDetails} />
                <StStatLine
                    className="material-link"
                    title={t('components.productStatistics.addedByLibraries')}
                    detail={detailView}
                >
                    <StMaterialIcon icon="home" detail={detailView} />
                    {detailView ? (
                        <Trans
                            i18nKey="components.productStatistics.addedByLibrariesWithLabels"
                            components={{ span: <span /> }}
                            values={{ activeLibraries }}
                        />
                    ) : (
                        <StStatisticsLabel>{activeLibraries}</StStatisticsLabel>
                    )}
                </StStatLine>
            </ul>
        </div>
    );
};
